// extracted by mini-css-extract-plugin
export default {"product-volume-icon":"ProductFilterMenuRender_product-volume-icon__0UJOS"};